export const PERIODS = {
  MONTHLY: 'monthly',
  LIFE_LONG: 'life_long',
};

export const SKUS = {
  AI_RECEPTIONIST_CHAT: 'ai_receptionist_chat',
  AI_RECEPTIONIST_CREDIT: 'ai_receptionist_credit',
  AI_CREDIT: 'ai_credit',
  SMS: 'sms',
};

export const COUNTABLE_SKUS = [
  SKUS.AI_RECEPTIONIST_CHAT,
  SKUS.AI_RECEPTIONIST_CREDIT,
  SKUS.AI_CREDIT,
  SKUS.SMS,
];

export const PAYMENT_TYPES = {
  SINGLE_CHARGE: 'single_charge',
};

const EXTERNAL_PAYMENT_TYPES = ['external', 'external_single_charge'];

const COUNTABLE_ICONS = {
  [SKUS.AI_RECEPTIONIST_CHAT]: 'ChatsIcon',
  [SKUS.AI_RECEPTIONIST_CREDIT]: 'ChatsIcon',
  [SKUS.AI_CREDIT]: 'TokensIcon',
  [SKUS.SMS]: 'SmsIcon',
};

const DEFAULT_ICON = 'TokensIcon';

export const AUTO_RELOAD_SKUS = [SKUS.SMS];

export const iconFor = (sku) => COUNTABLE_ICONS[sku] || DEFAULT_ICON;
export const nameKeyFor = (sku) => `usage.countables.${sku}.name`;
export const isSingleCharge = (offering) => offering?.payment_type === PAYMENT_TYPES.SINGLE_CHARGE;
export const isExternal = (offering) => EXTERNAL_PAYMENT_TYPES.includes(offering?.payment_type);
export const isPurchasable = (offering) => !isExternal(offering);
